// =============================================================================
// web/shims/livekit-react-native.js — WEB shim for @livekit/react-native.
//
// @livekit/react-native is a NATIVE (WebRTC pod) binding; it cannot load in a web
// bundle. Voice/video calling is a native-only feature for the web target. The
// call screens (VoiceCallScreen / VoiceRoomScreen) are lazy-loaded (App.tsx
// getComponent) and, on web, degrade to a "not available" fallback because this
// shim throws when a live call is actually initialized — the lazy-loader
// (safeLazyScreen) catches that and shows makeUnavailable(...). Merely importing
// this module (e.g. ConnectionBanner referencing types) is safe and no-ops.
//
// Native iOS resolves the real package untouched.
// =============================================================================
function unavailable() {
  throw new Error('LiveKit calling is not available on the web build of CRYB.');
}

// registerGlobals is called lazily by services/livekit-globals.ts before a call.
// On web it is a no-op (there is no native WebRTC module to register).
export function registerGlobals() {}

// Hooks referenced by voice components — return inert defaults so a component that
// imports them can still render (it will show the "not available" path).
export function useRoom() {
  return { room: null };
}
export function useParticipant() {
  return {};
}
export function useConnectionQualityIndicator() {
  return { quality: 'unknown', isSpeaking: false };
}
export function useRoomContext() {
  return null;
}
export function useTracks() {
  return [];
}
export function useConnectionState() {
  return 'disconnected';
}
export function useDataChannel() {
  return { send: () => {}, message: undefined };
}
export function useLocalParticipant() {
  return { localParticipant: null };
}
export function useParticipants() {
  return [];
}

// The imperative Room/connection surface throws only when actually used.
export const AudioSession = {
  startAudioSession: unavailable,
  stopAudioSession: unavailable,
  configureAudio: () => {},
};

export const LiveKitRoom = function LiveKitRoomShim() {
  return null;
};

// Inert render/helper exports referenced by the (lazy, web-unavailable) call
// screens so the bundle resolves them; they never run on web.
export const VideoTrack = function VideoTrackShim() {
  return null;
};
export function isTrackReference() {
  return false;
}
export const AndroidAudioTypePresets = {
  communication: {},
  media: {},
};

export default {
  registerGlobals,
  AudioSession,
  LiveKitRoom,
};
